import { create } from 'zustand';
import { createSelectors, withDevtools, StoreName } from '../config';
import {
  createInitialData,
  createDataActions,
  createSearchActions,
  initialSearchSlice,
} from '../types';
import { companyClient } from 'shared/domain/company/companyClient';
import { contractClient } from 'shared/domain/contract/contractClient';
import type { ContractModel } from 'shared/domain/contract/types/model';
import { EntityName } from 'shared/domain/entityName';
import { createEntityCollectionActions } from '../entityCollection';
import type { ContractsStore } from './types';

export const contractSearchableFields = [
  'label',
  'createdBy.label',
  'parties.companyShortLabel',
  'parties.companyLongLabel',
];

const useContractsStoreBase = create<ContractsStore>()(
  withDevtools(
    (set, get) => ({
      data: createInitialData<ContractModel>(),
      search: initialSearchSlice,

      actions: {
        ...createDataActions<ContractModel, ContractsStore>(set),
        ...createSearchActions<ContractsStore>(set),
        // Contract parties show company labels.
        ...createEntityCollectionActions(
          { client: contractClient, entityName: EntityName.contracts, reloadOnChangesOf: [companyClient] },
          () => get().actions
        ),

        reset: () =>
          set((state) => ({
            ...state,
            data: createInitialData<ContractModel>(),
            search: initialSearchSlice,
          })),
      },
    }),
    StoreName.Contracts
  )
);

export const useContractsStore = createSelectors(useContractsStoreBase);

export const getContractsStoreState = (): ContractsStore =>
  useContractsStore.getState();
